// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getTerritories} from '../../shared/repositories/territories';

export const readTerritories = racfId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const territories = await getTerritories(racfId);

            dispatch({
                territories,
                type: actions.UPDATE_USER_TERRITORIES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/get-territories.js